    <div id="garage">
        <p-confirmDialog />

        <div class="section-header">
            <div class="section-tabs">
                <button class="section-tab"
                        [class.active]="selectedTab === 'garage'"
                        (click)="selectTab('garage')">
                    <i class="pi pi-warehouse"></i>
                    {{ 'dashboard.garage' | transloco }}
                </button>
                <button class="section-tab" id="tour-tab-vcus"
                        [class.active]="selectedTab === 'vcus'"
                        (click)="selectTab('vcus')">
                    <i class="pi pi-microchip"></i>
                    {{ 'dashboard.vcus' | transloco }}
                </button>
            </div>
            <div class="section-toolbar" *ngIf="selectedTab === 'garage'">
                <div class="search-box ftds-chamfer-bordered">
                    <i class="pi pi-search search-box-icon"></i>
                    <input type="text"
                           placeholder="{{ 'project.detail.tableShare.search' | transloco }}"
                           [(ngModel)]="filterValue"
                           (input)="applyFilter()" />
                </div>
                <button class="add-project-btn" (click)="addProject()"
                        *ngIf="projects.length === 0 || projects.length === 2">
                    <i class="pi pi-plus"></i>
                    {{ 'dashboard.addProject' | transloco }}
                </button>
            </div>
        </div>

        <!-- ═══ VCU MANAGEMENT (tab Minhas VCUs) ═══ -->
        <div class="vcus-section" *ngIf="selectedTab === 'vcus'">
            <app-vcu-list-pair></app-vcu-list-pair>
        </div>

        <div *ngIf="!isLoading">
            <!-- Layout especial para único projeto: card + painel de resumo + card "Novo Projeto" -->
            <div class="single-project-layout" *ngIf="projects.length === 1 && selectedTab === 'garage'">
                <div class="single-project-card">
                    <app-card-project
                        [project]="projects[0]"
                        [user]="userID"
                        [shared]="false"
                        (refreshDashboard)="refreshList()">
                    </app-card-project>
                </div>

                <div class="single-project-summary">
                    <div class="summary-stats-grid">
                        <div class="stat-box">
                            <span class="stat-value">{{ (singleProjectDetail || projects[0]).vcus.length }}</span>
                            <span class="stat-label"><i class="pi pi-microchip"></i> VCUs</span>
                        </div>
                        <div class="stat-box">
                            <span class="stat-value">{{ (singleProjectDetail || projects[0]).maps.length }}</span>
                            <span class="stat-label"><i class="pi pi-map"></i> {{ 'dashboard.project.maps' | transloco }}</span>
                        </div>
                        <div class="stat-box">
                            <span class="stat-value">{{ (singleProjectDetail || projects[0]).logs.length }}</span>
                            <span class="stat-label"><i class="pi pi-file"></i> {{ 'dashboard.project.logs' | transloco }}</span>
                        </div>
                        <div class="stat-box">
                            <span class="stat-value">{{ projects[0].likes || 0 }}</span>
                            <span class="stat-label"><i class="pi pi-heart"></i> {{ 'dashboard.project.likes' | transloco }}</span>
                        </div>
                    </div>

                    <div class="summary-info-rows">
                        <div class="summary-info-row" *ngIf="(singleProjectDetail || projects[0]).vehicle?.manufacturer || (singleProjectDetail || projects[0]).vehicle?.model">
                            <span class="summary-info-label">{{ 'dashboard.project.vehicle' | transloco }}</span>
                            <span class="summary-info-value">{{ (singleProjectDetail || projects[0]).vehicle?.manufacturer }} {{ (singleProjectDetail || projects[0]).vehicle?.model }}</span>
                        </div>
                        <div class="summary-info-row" *ngIf="(singleProjectDetail || projects[0]).status">
                            <span class="summary-info-label">{{ 'common.labels.status' | transloco }}</span>
                            <span class="summary-info-value">{{ (singleProjectDetail || projects[0]).status }}</span>
                        </div>
                        <div class="summary-info-row" *ngIf="(singleProjectDetail || projects[0]).application?.length">
                            <span class="summary-info-label">{{ 'dashboard.project.application' | transloco }}</span>
                            <span class="summary-info-value summary-tags-wrap">
                                <span class="summary-tag electric" *ngFor="let app of (singleProjectDetail || projects[0]).application">{{ app.name }}</span>
                            </span>
                        </div>
                        <div class="summary-info-row" *ngIf="(singleProjectDetail || projects[0]).equipments?.length">
                            <span class="summary-info-label">{{ 'dashboard.project.equipments' | transloco }}</span>
                            <span class="summary-info-value summary-tags-wrap">
                                <span class="summary-tag" *ngFor="let eq of (singleProjectDetail || projects[0]).equipments">{{ eq.name }}</span>
                            </span>
                        </div>
                        <div class="summary-info-row" *ngIf="(singleProjectDetail || projects[0]).tags?.length">
                            <span class="summary-info-label">{{ 'common.labels.tags' | transloco }}</span>
                            <span class="summary-info-value summary-tags-wrap">
                                <span class="summary-tag" *ngFor="let tag of (singleProjectDetail || projects[0]).tags">{{ tag }}</span>
                            </span>
                        </div>
                    </div>

                    <div class="summary-actions">
                        <button class="summary-action-btn" (click)="goToProjectDetail(projects[0])">
                            <i class="pi pi-folder-open"></i> {{ 'dashboard.project.viewDetails' | transloco }}
                        </button>
                        <button class="summary-action-btn" (click)="goToVcuManagement()">
                            <i class="pi pi-microchip"></i> {{ 'dashboard.project.manageVcus' | transloco }}
                        </button>
                    </div>
                </div>

                <div class="new-project-card" (click)="addProject()">
                    <i class="pi pi-plus-circle new-project-icon"></i>
                    <span class="new-project-label">{{ 'dashboard.project.newProject' | transloco }}</span>
                </div>
            </div>

            <!-- Layout duplo: 2 projetos, cada um com card + painel de resumo -->
            <div class="dual-project-layout" *ngIf="projects.length === 2 && selectedTab === 'garage'">
                <ng-container *ngFor="let project of projects; let i = index">
                    <div class="project-pair">
                        <div class="single-project-card">
                            <app-card-project
                                [project]="project"
                                [user]="userID"
                                [shared]="false"
                                (refreshDashboard)="refreshList()">
                            </app-card-project>
                        </div>
                        <div class="single-project-summary">
                            <div class="summary-stats-grid">
                                <div class="stat-box">
                                    <span class="stat-value">{{ (projectDetails[i] || project).vcus.length }}</span>
                                    <span class="stat-label"><i class="pi pi-microchip"></i> VCUs</span>
                                </div>
                                <div class="stat-box">
                                    <span class="stat-value">{{ (projectDetails[i] || project).maps.length }}</span>
                                    <span class="stat-label"><i class="pi pi-map"></i> {{ 'dashboard.project.maps' | transloco }}</span>
                                </div>
                                <div class="stat-box">
                                    <span class="stat-value">{{ (projectDetails[i] || project).logs.length }}</span>
                                    <span class="stat-label"><i class="pi pi-file"></i> {{ 'dashboard.project.logs' | transloco }}</span>
                                </div>
                                <div class="stat-box">
                                    <span class="stat-value">{{ project.likes || 0 }}</span>
                                    <span class="stat-label"><i class="pi pi-heart"></i> {{ 'dashboard.project.likes' | transloco }}</span>
                                </div>
                            </div>
                            <div class="summary-info-rows">
                                <div class="summary-info-row" *ngIf="(projectDetails[i] || project).vehicle?.manufacturer || (projectDetails[i] || project).vehicle?.model">
                                    <span class="summary-info-label">{{ 'dashboard.project.vehicle' | transloco }}</span>
                                    <span class="summary-info-value">{{ (projectDetails[i] || project).vehicle?.manufacturer }} {{ (projectDetails[i] || project).vehicle?.model }}</span>
                                </div>
                                <div class="summary-info-row" *ngIf="(projectDetails[i] || project).status">
                                    <span class="summary-info-label">{{ 'common.labels.status' | transloco }}</span>
                                    <span class="summary-info-value">{{ (projectDetails[i] || project).status }}</span>
                                </div>
                                <div class="summary-info-row" *ngIf="(projectDetails[i] || project).application?.length">
                                    <span class="summary-info-label">{{ 'dashboard.project.application' | transloco }}</span>
                                    <span class="summary-info-value summary-tags-wrap">
                                        <span class="summary-tag electric" *ngFor="let app of (projectDetails[i] || project).application">{{ app.name }}</span>
                                    </span>
                                </div>
                                <div class="summary-info-row" *ngIf="(projectDetails[i] || project).equipments?.length">
                                    <span class="summary-info-label">{{ 'dashboard.project.equipments' | transloco }}</span>
                                    <span class="summary-info-value summary-tags-wrap">
                                        <span class="summary-tag" *ngFor="let eq of (projectDetails[i] || project).equipments">{{ eq.name }}</span>
                                    </span>
                                </div>
                                <div class="summary-info-row" *ngIf="(projectDetails[i] || project).tags?.length">
                                    <span class="summary-info-label">{{ 'common.labels.tags' | transloco }}</span>
                                    <span class="summary-info-value summary-tags-wrap">
                                        <span class="summary-tag" *ngFor="let tag of (projectDetails[i] || project).tags">{{ tag }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="summary-actions">
                                <button class="summary-action-btn" (click)="goToProjectDetail(project)">
                                    <i class="pi pi-folder-open"></i> {{ 'dashboard.project.viewDetails' | transloco }}
                                </button>
                                <button class="summary-action-btn" (click)="goToVcuManagement()">
                                    <i class="pi pi-microchip"></i> {{ 'dashboard.project.manageVcus' | transloco }}
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- Grid padrão para 0 ou 3+ projetos -->
            <div class="projects-grid" *ngIf="(projects.length === 0 || projects.length > 2) && selectedTab === 'garage'">
                <div class="grid-item" *ngFor="let project of projects; let i = index" [style.animation-delay]="i * 50 + 'ms'">
                    <app-card-project [project]="project" [user]="userID" [shared]="false"
                        (refreshDashboard)="refreshList()"></app-card-project>
                </div>
                <div class="grid-item" *ngIf="projects.length > 2">
                    <div class="new-project-card new-project-card--grid" (click)="addProject()">
                        <i class="pi pi-plus-circle new-project-icon"></i>
                        <span class="new-project-label">{{ 'dashboard.project.newProject' | transloco }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="isLoading && selectedTab === 'garage'" class="skeleton-grid">
            <div class="skeleton-card" *ngFor="let s of [1,2,3,4]">
                <div class="skeleton-image shimmer"></div>
                <div class="skeleton-info">
                    <div class="skeleton-line title shimmer"></div>
                    <div class="skeleton-line tags shimmer"></div>
                    <div class="skeleton-line footer shimmer"></div>
                </div>
            </div>
        </div>
    </div>

    <!-- Garagem compartilhada (projetos compartilhados com o usuario) desativada.
    <div id="projects">
        <div class="section-header">
            <div class="section-tabs">
                <button class="section-tab active">
                    <i class="pi pi-share-alt"></i>
                    {{ 'dashboard.sharedGarage' | transloco }}
                </button>
            </div>
        </div>

        <div *ngIf="!isLoading">
            <div class="projects-grid" *ngIf="selectedTabFavorite === 'destaque'">
                <div class="grid-item" *ngFor="let project of sharedProjects; let i = index" [style.animation-delay]="i * 50 + 'ms'">
                    <app-card-favorite-projects [project]="project" [user]="userID" [shared]="true"
                        (refreshDashboard)="refreshList()"></app-card-favorite-projects>
                </div>
            </div>
        </div>

        <div *ngIf="isLoading" class="skeleton-grid">
            <div class="skeleton-card" *ngFor="let s of [1,2,3]">
                <div class="skeleton-image shimmer"></div>
                <div class="skeleton-info">
                    <div class="skeleton-line title shimmer"></div>
                    <div class="skeleton-line tags shimmer"></div>
                    <div class="skeleton-line footer shimmer"></div>
                </div>
            </div>
        </div>
    </div>
    -->


    
    <p-dialog id="modal-welcome" 
        name="modal-welcome" 
        [modal]="true" 
        [draggable]="false" 
        [(visible)]="showWelcomeDialog"
        (onHide)="onWelcomeHidden()" [style]="{'width': '900px','height': '620px'}">
        <div class="modal-content">
            <!-- Filete de acento no topo: a barra de luz do FT700 reduzida a uma linha. -->
            <span class="welcome-rule"></span>
            <div class="welcome-left">
                <span class="welcome-eyebrow">{{ 'welcomeTour.modal.eyebrow' | transloco }}</span>
                <h1 class="welcome-title">
                    {{ 'welcomeTour.modal.title' | transloco }}
                    <span class="welcome-title__product">{{ 'welcomeTour.modal.titleProduct' | transloco }}</span>
                </h1>
                <p class="welcome-lead">{{ 'welcomeTour.modal.lead' | transloco }}</p>
                <ul class="welcome-grid">
                    <li class="welcome-tile">
                        <span class="welcome-tile__head">
                            <i class="pi pi-warehouse"></i>
                            <span class="welcome-tile__label">{{ 'welcomeTour.modal.garageLabel' | transloco }}</span>
                        </span>
                        <span class="welcome-tile__text">{{ 'welcomeTour.modal.garage' | transloco }}</span>
                    </li>
                    <li class="welcome-tile">
                        <span class="welcome-tile__head">
                            <i class="pi pi-microchip"></i>
                            <span class="welcome-tile__label">{{ 'welcomeTour.modal.vcusLabel' | transloco }}</span>
                        </span>
                        <span class="welcome-tile__text">{{ 'welcomeTour.modal.vcus' | transloco }}</span>
                    </li>
                    <li class="welcome-tile">
                        <span class="welcome-tile__head">
                            <i class="pi pi-folder-open"></i>
                            <span class="welcome-tile__label">{{ 'welcomeTour.modal.archivesLabel' | transloco }}</span>
                        </span>
                        <span class="welcome-tile__text">{{ 'welcomeTour.modal.archives' | transloco }}</span>
                    </li>
                    <li class="welcome-tile">
                        <span class="welcome-tile__head">
                            <i class="ft-icon ft-icon-ftpilot"></i>
                            <span class="welcome-tile__label">{{ 'welcomeTour.modal.aiLabel' | transloco }}</span>
                        </span>
                        <span class="welcome-tile__text">{{ 'welcomeTour.modal.ai' | transloco }}</span>
                    </li>
                </ul>
                <div class="welcome-actions">
                    <p-button icon="pi pi-compass"
                        [label]="'welcomeTour.modal.takeTour' | transloco"
                        severity="danger" (onClick)="takeTourFromWelcome()" />
                    <p-button [label]="'welcomeTour.modal.skip' | transloco"
                        severity="secondary" [text]="true" (onClick)="showWelcomeDialog = false" />
                </div>
            </div>
            <div class="modal-right">
                <div class="img"></div>
            </div>

            
        </div>
    </p-dialog>
    <p-dialog id="modal-reactive-account" 
        name="modal-reactive-account" 
        [modal]="true" 
        [draggable]="false"
        [(visible)]="showReactiveAccountDialog" 
        (onHide)="closeModalReactiveAccount()"
        [style]="{'width': '900px','height': '700px'}">
        <div class="modal-content">
            <div class="modal-left">
                <h1>{{ 'user.account.reactive.header' | transloco }}</h1>
                <p>{{ reactiveAccountMessage }}</p>
                <div class="modal-footer">
                    <p-button id="btnNo" 
                        name="btnNo" 
                        label="{{ 'user.account.reactive.no' | transloco }}" 
                        severity="secondary" 
                        [raised]="true" 
                        (click)="logoutAccount()">
                    </p-button>
                    <p-button id="btnReactiveAccount" 
                        name="btnReactiveAccount" 
                        label="{{ 'user.account.reactive.yes' | transloco }}" 
                        severity="danger" 
                        [raised]="true"
                        (click)="ReactiveAccount()">
                    </p-button>
                </div>
            </div>
            <div class="modal-right">
                <div class="img"></div>
            </div>
        </div>
    </p-dialog>

        <!-- <p-dialog id="modal-event" 
            name="modal-event" 
            [modal]="true" 
            [draggable]="false" 
            [(visible)]="modalEvent"
            (onHide)="closeModal()" [style]="{'width': '30%','height': '713px', 'z-index': '9999'}">
            <div class="p-dialog-header" [style]="{'display':'none'}"></div>
            <div class="p-dialog" style="padding: 0;">
                <div class="p-dialog-content"
                style="
                background-image: url('/assets/img/ftchimarrao/ftgm.png');
                display: flex;
                justify-content: flex-end;
                width: 100%;
                background-size: cover;
                background-position: top;
                background-repeat: no-repeat;
                border-radius: 6px;
                ">
            </div>
            </div>
            

                <div class="modal-content-event">

                </div>
        </p-dialog> -->

        <p-dialog id="modal-event" name="modal-event" [modal]="true" 
            [draggable]="false" 
            [(visible)]="modalEvent" [style]="{'width': '30%', 'z-index': '9999'}">
            <div class="p-dialog-content" style="padding: 0;">
                <div class="modal-content-event">
                    <div class="button-wrapper" (click)="closeModalEvent()">
                        <div class="button-inner" style="background: #0000000d;">
                            <p-button id="btnBackLogin" name="btnBackLogin" [label]="'dashboard.event.dontShowAgain' | transloco" [raised]="true"
                                styleClass="custom-button"></p-button>
                        </div>
                    </div>
                    <div class="button-wrapper" (click)="goToEvent()">
                        <div class="button-inner" style="background: #bb0a0a;">
                            <p-button id="btnBackLogin" name="btnBackLogin" [label]="'dashboard.event.goToEvent' | transloco" [raised]="true"
                                styleClass="custom-button"></p-button>
                        </div>
                    </div>
                </div>

            </div>
        </p-dialog>


    <p-toast key="toastDashboard" />
    <app-vcu-identified [showDialog]="showVcuIdentifiedDialog" (closeDialog)="updateVcuIdentifiedDialog()"></app-vcu-identified>
    <app-register-project [showDialog]="showProjectDialog" (closeDialog)="updateProjectDialog()" (saved)="onProjectSaved()" [project]="null" [editMode]="false"></app-register-project>
